import React, { useEffect, useState } from 'react';
import DrilldownTable from '../../Dashboard/DefaultDashboard/DrillDownReports/Common/DrilldownTable';
import { AppConstant } from '../../../../../Assests/AppConstant';
import { getUserSelector } from '../../../../../../redux/reducers/reducerSlices/UserReducer';
import { getAuthReducer } from '../../../../../../redux/reducers/reducerSlices/AuthReducer';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { sagaActions } from '../../../../../../sagas/sagaActions';
import CommonToggleSwitch from '../../../../Common/CommonToggleSwitch/CommonToggleSwitch';
import _ from 'lodash';


const UserAssignRoleTable = (props) => {

    const { themeSelected, updateUserRolePayload, selectCompanyGroup, selectCompany, setWarehouseName, setRoleName, setSelectedUserAssign, allowPermissionR } = props;
    const [userAssignRoleData, setUserAssignRoleData] = useState([]);
    const [resenEmailLoader, setResenEmailLoader] = useState(false)
    const user = useSelector(getUserSelector)
    const { initateLoading, userRoleDetailsList, selectedUser, arrangeOrder, arrangeKey, resendEmail } = user;
    const [loadingIndex, setLoadingIndex] = useState(-1);
    const userAuth = useSelector(getAuthReducer);
    const dispatch = useDispatch()

    useEffect(() => {
        if(resendEmail){
            setResenEmailLoader(false)
            dispatch({ type: sagaActions.UPDATE_RESEND_EMAIL, payload: false})
        }
    },[resendEmail])

    const warehouseTitleDD = [
        { id: 'serial_num', name: 'S.No' },
        { id: 'Email', name: 'Email' },
        { id: 'GroupName', name: 'Company Group' },
        { id: 'CompanyName', name: 'Company' },
        { id: 'WarehouseName', name: 'Warehouse' },
        { id: 'RoleName', name: 'Role' },
        { id: 'CreatedOn', name: 'Created on' },
        { id: 'actions', name: 'Actions' },
    ]

    useEffect(() => {
        if (loadingIndex === -1) {
            setTimeout(() => {
                dispatch({ type: sagaActions.UPDATE_USER_ROLE_ASSIGN, payload: updateUserRolePayload('S')});
            },[0])
        }
    }, [loadingIndex])

    useEffect(() => {
        dispatch({ type: sagaActions.INITIATE_LOADING, payload: true })
        setTimeout(() => {
            dispatch({ type: sagaActions.UPDATE_USER_ROLE_ASSIGN, payload: updateUserRolePayload('S') })
        },[0])
    }, [])

    useEffect(() => {
        setLoadingIndex(-1)
        if (userRoleDetailsList.length) {
            initateLoading && dispatch({ type: sagaActions.INITIATE_LOADING, payload: false })
            let data = formatListData(userRoleDetailsList)
            setUserAssignRoleData(data)
        }
    }, [userRoleDetailsList])


    const assignUserType = (obj) => {
        obj.user_type = selectedUser.UserType;
    };

    const assignNotificationStatus = (obj, user, toggleType) => {
        obj.SmsStatus = toggleType === 'sms' ? !user.SmsStatus : user.SmsStatus;
        obj.EmailStatus = toggleType === 'email' ? !user.EmailStatus : user.EmailStatus;
    };

    const clickHandler = (key, user, index) => {

        setSelectedUserAssign(user)
        let obj = { enable_status: true, cu_id: null, wh_id: null, role_id: null, crud_type: null, updated_object: null, comp_group_id: null, comp_id: null, user_wh_role_id: null }
        switch (key) {
            case AppConstant.commonStrings.edit:
                selectCompanyGroup({ GroupName: user.GroupName, CompanyGroupId: user.CompanyGroupId })
                selectCompany({ CompanyName: user.CompanyName, CompanyId: user.CompanyId })
                setWarehouseName({ WarehouseName: user.WarehouseName, ID: user.WarehouseID })
                setRoleName({ RoleName: user.RoleName, RoleID: user.RoleID })
                break;
            case AppConstant.commonStrings.disable:
                obj.cu_id = selectedUser.CUID
                obj.crud_type = 'D'
                obj.wh_id = user.WarehouseID
                obj.enable_status = false
                obj.user_wh_role_id = user.UserWHRoleID
                assignUserType(obj);
                dispatch({ type: sagaActions.UPDATE_USER_ROLE_ASSIGN, payload: obj })
                break;
            case AppConstant.commonStrings.enable:
                obj.cu_id = selectedUser.CUID
                obj.crud_type = 'D'
                obj.wh_id = user.WarehouseID
                obj.enable_status = true
                obj.user_wh_role_id = user.UserWHRoleID
                assignUserType(obj);
                dispatch({ type: sagaActions.UPDATE_USER_ROLE_ASSIGN, payload: obj })
                break;
            case AppConstant.commonStrings.resendEmail:
                setResenEmailLoader(user.CUID)
                dispatch({ type: sagaActions.INITIATE_RESEND_EMAIL, payload: { username: user.Email, IDWarehouse : user.WarehouseID, usernameVal: `${user.FirstName +" "+ user.LastName}` } })
                break;
            case 'sms':
                obj.cu_id = selectedUser.CUID
                obj.crud_type = 'E'
                obj.wh_id = user.WarehouseID
                obj.user_wh_role_id = user.UserWHRoleID
                assignUserType(obj);
                assignNotificationStatus(obj, user, 'sms');
                obj.UserID = user.CUID
                dispatch({ type: sagaActions.UPDATE_USER_ROLE_ASSIGN, payload: obj })
                break;
            case 'email':
                obj.cu_id = selectedUser.CUID
                obj.crud_type = 'E'
                obj.wh_id = user.WarehouseID
                obj.user_wh_role_id = user.UserWHRoleID
                assignUserType(obj);
                assignNotificationStatus(obj, user, 'email');
                obj.UserID = user.CUID
                dispatch({ type: sagaActions.UPDATE_USER_ROLE_ASSIGN, payload: obj })
                break;

            default:
                break;
        }

        setLoadingIndex(index)
    }

    const actionsButton = (el, index) => {
        return (
            <div className='d-flex flex-row align-items-center justify-content-center gap-2 flex-wrap'>
                {/* Edit */}
                <button
                    title="Edit"
                    onClick={() => clickHandler(AppConstant.commonStrings.edit, el, index)}
                    className="action-icon-btn no-bg no-border action-icon-edit"
                    data-bs-toggle="modal"
                    data-bs-target="#editUserAssignRolesFormPopup"
                >
                    <i className="fa-solid fa-pen-to-square" style={{ fontSize: '16px' }}></i>
                </button>
                {/* Enable / Disable toggle */}
                <div title={el.EnableStatus ? 'Click to Disable' : 'Click to Enable'} className="d-flex align-items-center">
                    <CommonToggleSwitch
                        value={el.EnableStatus}
                        allowPermissionD={true}
                        onChangeValue={() => clickHandler(
                            el.EnableStatus ? AppConstant.commonStrings.disable : AppConstant.commonStrings.enable,
                            el,
                            index
                        )}
                    />
                </div>
                {/* Resend Email */}
                <button
                    title="Resend Email"
                    onClick={() => clickHandler(AppConstant.commonStrings.resendEmail, el, index)}
                    className="action-icon-btn no-bg no-border action-icon-email"
                >
                    {el.CUID === resenEmailLoader
                        ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        : <i className="fa-regular fa-envelope" style={{ fontSize: '16px' }}></i>
                    }
                </button>
                {/* SMS Toggle — hidden for Administrator */}
                {_.upperCase(selectedUser?.UserType) !== AppConstant.userPermission.usertypes.administrator && (
                    <div
                        title={el.SmsStatus ? 'SMS: Click to Disable' : 'SMS: Click to Enable'}
                        className="d-flex align-items-center gap-1"
                    >
                        <CommonToggleSwitch
                            value={el.SmsStatus}
                            allowPermissionD={true}
                            onChangeValue={() => clickHandler('sms', el, index)}
                        />
                    </div>
                )}
                {/* Email Status Toggle — hidden for Administrator */}
                {_.upperCase(selectedUser?.UserType) !== AppConstant.userPermission.usertypes.administrator && (
                    <div
                        title={el.EmailStatus ? 'Email: Click to Disable' : 'Email: Click to Enable'}
                        className="d-flex align-items-center gap-1"
                    >
                        <CommonToggleSwitch
                            value={el.EmailStatus}
                            allowPermissionD={true}
                            onChangeValue={() => clickHandler('email', el, index)}
                        />
                    </div>
                )}
            </div>
        )
    }

    const formatListData = (data) => {
        return data.map((el, index) => {
            return {
                id: el.CUID + el.UserWHRoleID || index,
                0: (index + 1),
                1: el.Email,
                2: el.GroupName,
                3: el.CompanyName,
                4: el.WarehouseName,
                5: el.RoleName,
                6: el.CreatedOn,
                7: actionsButton(el, index),
            }
        })
    }

    return (
        <DrilldownTable
            themeSelected={themeSelected}
            bodyData={userAssignRoleData}
            titleData={warehouseTitleDD}
            showCollapse={false}
            showInput={false}
            showSort={true}
            arrangeOrder={arrangeOrder}
            arrangeKey={arrangeKey}
            drillDownReport={userRoleDetailsList}
            initiateDrillDownReport={initateLoading}
            loaderArray={8}
            sortingAction={sagaActions.SORT_USER_TABLE}
            subRoot={{ pathName: 'userAssign' }}
            showUTCTime={false}
        />
    )
}

export default UserAssignRoleTable;